import type { CityConfig } from "../city-template/types";

export const martinsburgConfig: CityConfig = {
  city: "Martinsburg",
  state: "West Virginia",
  stateAbbr: "WV",
  slug: "martinsburg",
  route: "/martinsburg",
  title: "Emergency Passport Martinsburg, WV — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Martinsburg, WV — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Eastern Panhandle, DC commuters, and Berkeley County travelers via Dulles and BWI airports.",
  h1: "Emergency & Expedited Passport Services in Martinsburg, WV",
  heroSubtitle: "MARC train to DC then Dulles flight to Dubai in two weeks? IRS Computing Center international training in London? Shepherd University study abroad in Barcelona? We help Martinsburg residents — from downtown commuters to Spring Mills families to Inwood professionals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Wide%20panoramic%20view%20of%20Martinsburg%20West%20Virginia%20historic%20downtown%20district%20with%20brick%20storefronts%20and%20the%20Baltimore%20and%20Ohio%20Railroad%20roundhouse%2C%20warm%20afternoon%20light%20casting%20long%20shadows%20across%20Queen%20Street%2C%20Blue%20Ridge%20Mountains%20visible%20in%20the%20distance%2C%20small%20city%20charm%20with%20train%20history%20and%20Appalachian%20foothills%20backdrop%2C%20Eastern%20Panhandle%20community%20atmosphere&width=1800&height=700&seq=martinsburg-hero-2026&orientation=landscape",
  heroImageAlt: "Martinsburg West Virginia historic downtown with train roundhouse and Blue Ridge Mountains",
  geoPosition: "39.4562;-77.9639",
  geoPlacename: "Martinsburg, West Virginia",
  lastModified: "2026-06-07",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 80 miles from Martinsburg — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Martinsburg", zips: "25401, 25402, 25403, 25404, 25405" },
    { name: "Shepherdstown", zips: "25443" },
    { name: "Inwood", zips: "25428" },
    { name: "Falling Waters", zips: "25419" },
    { name: "Hedgesville", zips: "25427" },
    { name: "Charles Town", zips: "25414" },
    { name: "Ranson", zips: "25438" },
    { name: "Harpers Ferry", zips: "25425" },
    { name: "Winchester, VA", zips: "22601, 22602, 22603, 22604" },
    { name: "Hagerstown, MD", zips: "21740, 21741, 21742" },
  ],
  benefits: [
    { icon: "ri-train-line", title: "DC Commuter + International Traveler", desc: "Martinsburg is the western terminus of the MARC commuter rail to DC — meaning many residents commute to Washington and also depart internationally from Dulles (IAD) and BWI. We understand the commuter lifestyle and tight timelines." },
    { icon: "ri-flight-takeoff-line", title: "Triple Airport Access", desc: "Martinsburg uniquely sits within 60–80 miles of three major international airports — Dulles (IAD), Reagan National (DCA), and BWI. We coordinate your passport timeline with your specific airport, airline, and departure time." },
    { icon: "ri-building-2-line", title: "Federal & Government Travel", desc: "The IRS Computing Center, VA Medical Center, and US Coast Guard operations in the Eastern Panhandle generate regular government and contractor international travel — often on short notice with fixed deployment or training dates." },
    { icon: "ri-graduation-cap-line", title: "Shepherd University & School Travel", desc: "Shepherd University study abroad programs, Blue Ridge CTC students, and Eastern Panhandle high school international trips all create first-time and urgent passport needs during the academic calendar." },
  ],
  testimonials: [
    {
      name: "Michael R.",
      location: "Downtown Martinsburg",
      rating: 5,
      text: "IRS Computing Center sent me to London for cybersecurity training with 12 days notice. My passport was expired and I commute to DC daily — no time for an agency visit. They handled everything and my passport arrived in 5 days.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Rebecca T.",
      location: "Spring Mills",
      rating: 5,
      text: "Shepherd University study abroad to Barcelona — first passport ever. The checklist was perfect for a first-timer, the Martinsburg post office visit was smooth, and my passport arrived before orientation. Couldn't have been easier.",
      service: "New Passport — First Time",
    },
    {
      name: "The Chen Family",
      location: "Inwood",
      rating: 5,
      text: "Trip to China from Dulles — realized all three of us needed passport work. One renewal, one new child passport, one name change. They handled all three applications simultaneously and we had everything in 10 days.",
      service: "Multiple Passport Services",
    },
    {
      name: "David K.",
      location: "Falling Waters",
      rating: 5,
      text: "Contractor deploying to Germany with 8 days notice. Needed a second passport since my primary was with the German consulate for a work visa. They expedited the second passport and I made my deployment date.",
      service: "Second Passport — Expedited",
    },
  ],
  facilities: [
    {
      id: "martinsburg-1",
      name: "Martinsburg Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1359 Edwin Miller Blvd",
      city: "Martinsburg",
      state: "WV",
      zip: "25404",
      phone: "(304) 263-4671",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Martinsburg — Edwin Miller Boulevard",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary acceptance facility for Martinsburg and Berkeley County. Passport photos available on-site. Appointment required — schedule at least a week in advance during summer travel season.",
      icon: "ri-mail-line",
    },
    {
      id: "martinsburg-2",
      name: "Berkeley County Circuit Clerk",
      type: "County Clerk Passport Acceptance",
      address: "380 W South St, Suite 1100",
      city: "Martinsburg",
      state: "WV",
      zip: "25401",
      phone: "(304) 264-1918",
      hours: "Mon–Fri 8:30 AM – 4:30 PM",
      distance: "Downtown Martinsburg — Judicial Center",
      website: "https://www.berkeleywv.org/circuitclerk",
      websiteLabel: "Berkeley County Clerk",
      notes: "County clerk passport acceptance counter in the Judicial Center. Often less crowded than the post office. No photo services on-site — obtain passport photos before visiting.",
      icon: "ri-government-line",
    },
    {
      id: "martinsburg-3",
      name: "Shepherdstown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 E German St",
      city: "Shepherdstown",
      state: "WV",
      zip: "25443",
      phone: "(304) 876-2455",
      hours: "Mon–Fri 9:00 AM – 3:00 PM",
      distance: "Shepherdstown — 10 miles east, Jefferson County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serving Jefferson County and Shepherd University community. Limited afternoon hours — call ahead to confirm availability. Convenient for Shepherdstown and southern Berkeley County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "martinsburg-4",
      name: "Hagerstown Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "44 W Franklin St",
      city: "Hagerstown",
      state: "MD",
      zip: "21740",
      phone: "(301) 733-9260",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Hagerstown, MD — 20 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Alternative facility for northern Berkeley County residents. Serves Washington County, MD. Photo services available. Larger facility with more appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "martinsburg-5",
      name: "Winchester Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "132 N Loudoun St",
      city: "Winchester",
      state: "VA",
      zip: "22601",
      phone: "(540) 662-7538",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Winchester, VA — 25 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serving Frederick County, VA and southern Berkeley County residents. Alternative to Martinsburg facilities when appointments are full. Photo services available.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    { q: "How fast can I get a passport in Martinsburg?", a: "We offer Martinsburg-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. Unlike most West Virginia cities, Martinsburg is only 80 miles from the Washington, DC Passport Agency — but appointments are still required and typically booked 2+ weeks out. Our courier service is faster and more predictable." },
    { q: "Do I need to visit an office in Martinsburg?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Martinsburg Main Post Office or Berkeley County Clerk), then ship documents overnight. We handle the State Department submission and return your passport to your Martinsburg address." },
    { q: "Which airport should Martinsburg travelers use?", a: "Martinsburg has a unique advantage — three major international airports within 80 miles. Washington Dulles (IAD, ~60 miles) is the primary choice with the most international routes. Reagan National (DCA, ~80 miles) offers convenient connections. Baltimore-Washington (BWI, ~75 miles) is a major Southwest hub. We build your specific airport into the timeline." },
    { q: "Can DC commuters use Martinsburg passport services?", a: "Yes — many Martinsburg residents commute to DC via MARC train but prefer to handle passport matters locally. The Martinsburg Main Post Office and Berkeley County Clerk serve as acceptance facilities. Our remote courier service handles the rest — no need to visit a DC passport office." },
    { q: "What is the best price for expedited passport service in Martinsburg?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. Best price guarantee included." },
    { q: "Where can I get passport photos in Martinsburg?", a: "CVS Pharmacy on Edwin Miller Boulevard, Walgreens on Winchester Avenue, Walmart on Foxcroft Avenue, and the Martinsburg Main Post Office all offer passport photos. The UPS Store on Foxcroft Avenue also provides photo services." },
    { q: "Does Shepherd University offer passport services?", a: "Shepherd University does not have a dedicated passport office, but the Shepherdstown Post Office (100 E German St) and Martinsburg facilities are a short drive away. We provide student-specific guidance for study abroad, mission trips, and international programs." },
    { q: "What about government and federal employee travel?", a: "The Martinsburg area has a significant federal workforce — IRS Computing Center, VA Medical Center, US Coast Guard operations, and DC-based agency employees who live in the Eastern Panhandle. We understand government travel authorization timelines, deployment schedules, and the unpredictability of federal training assignments." },
    { q: "Can I use Maryland or Virginia acceptance facilities?", a: "Yes — many Martinsburg residents use the Hagerstown, MD post office (20 miles north) or Winchester, VA post office (25 miles south) as acceptance facilities. These are fully valid options and often have more appointment availability than Martinsburg facilities during peak seasons." },
    { q: "How do I check my passport status from Martinsburg?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online status system. Processing from submission to return typically matches your chosen speed tier." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Edwin Miller Blvd", address: "1365 Edwin Miller Blvd, Martinsburg, WV 25404", hours: "Daily 8 AM – 9 PM" },
    { name: "Walgreens — Winchester Ave", address: "1330 Winchester Ave, Martinsburg, WV 25405", hours: "Daily 8 AM – 10 PM" },
    { name: "Walmart Supercenter — Foxcroft Ave", address: "800 Foxcroft Ave, Martinsburg, WV 25401", hours: "Daily 6 AM – 11 PM" },
    { name: "The UPS Store — Foxcroft Ave", address: "748 Foxcroft Ave, Martinsburg, WV 25401", hours: "Mon–Fri 8:30 AM – 6 PM, Sat 9 AM – 1 PM" },
    { name: "Martinsburg Main Post Office", address: "1359 Edwin Miller Blvd, Martinsburg, WV 25404", hours: "Mon–Fri 9 AM – 4 PM" },
  ],
  dmvLocations: [
    {
      name: "WV DMV — Martinsburg Regional Office",
      address: "38 Kelly Island Rd, Martinsburg, WV 25405",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Driver licenses, REAL ID, state ID cards. Appointment recommended.",
      featured: true,
    },
  ],
  dmvWebsite: "https://transportation.wv.gov/dmv/",
  dmvLabel: "West Virginia DMV — Official Website",
  airports: [
    {
      code: "IAD",
      name: "Washington Dulles International Airport",
      distance: "About 60 miles east of Martinsburg",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Primary international gateway for Eastern Panhandle travelers. United Airlines hub with direct flights to Europe, Asia, Middle East, and Latin America. About 60–75 minutes via WV-9 and VA-267.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "Dulles Airport Website",
      featured: true,
    },
    {
      code: "BWI",
      name: "Baltimore-Washington International Airport",
      distance: "About 75 miles east of Martinsburg",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Major Southwest Airlines hub with international service to Caribbean, Mexico, and Europe. About 75–90 minutes via I-70 and I-695.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport Website",
      featured: false,
    },
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "About 80 miles southeast of Martinsburg",
      address: "2401 Ronald Reagan Washington National Airport Access Rd, Arlington, VA 22202",
      note: "Convenient for domestic connections to international gateways. American Airlines hub. About 80–90 minutes via WV-9 and I-66/I-395.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport Website",
      featured: false,
    },
  ],
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate — WV DHHR",
      desc: "Request certified birth certificates from the West Virginia DHHR Vital Registration Office. Online, mail, or in-person options.",
      url: "https://dhhr.wv.gov/bph/hsc/vital/Pages/default.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate — Berkeley County",
      desc: "Request marriage license records from the Berkeley County Clerk. Certified copies for name changes and passport applications.",
      url: "https://www.berkeleywv.org/countyclerk",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree — Berkeley County",
      desc: "Obtain certified divorce records through the Berkeley County Circuit Clerk for name change passport corrections.",
      url: "https://www.berkeleywv.org/circuitclerk",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate — WV DHHR",
      desc: "Certified death certificates through WV DHHR for estate and legal matters.",
      url: "https://dhhr.wv.gov/bph/hsc/vital/Pages/default.aspx",
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Dulles flight to Frankfurt in two days? Federal deployment or training with short notice? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Martinsburg residents renew fast — no agency visit required. Perfect for DC commuters, government employees, and Eastern Panhandle families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport — First Time",
      description: "First-time applicants require an in-person acceptance visit. We guide Martinsburg residents through every step with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require DS-64 and additional documentation. We guide you through everything to avoid costly mistakes — so your deployment, training, or vacation stays on track.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear checklists so your family vacation or international trip stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so your travel documents match IDs and reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for federal employees, government contractors, and consultants traveling while a primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Eastern Panhandle travelers through the process.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "Wallet-size travel document for land and sea crossings to Canada, Mexico, Caribbean, and Bermuda — expedited with the same courier service.",
      bullets: ["Wallet-size convenience", "Land and sea travel", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Martinsburg WV", description: "Urgent passport processing for Martinsburg West Virginia travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Martinsburg WV", description: "Fast passport renewal for Martinsburg West Virginia residents." },
    { name: "First-Time Passport Martinsburg WV", description: "New passport application services for Martinsburg West Virginia residents." },
    { name: "Child Passport Martinsburg WV", description: "Minor passport services for Martinsburg West Virginia families." },
    { name: "Name Change Passport Martinsburg WV", description: "Passport name correction for Martinsburg residents." },
    { name: "Second Passport Martinsburg WV", description: "Second passport services for Martinsburg federal and international travelers." },
  ],
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Picking the Wrong Airport for Your Destination",
      description: "With three major airports within 80 miles, Martinsburg travelers sometimes book flights from different airports without realizing each has different check-in requirements, drive times, and international route availability. We help you plan the full timeline for your specific airport and destination.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Relying on Being Close to DC for Faster Processing",
      description: "Martinsburg is only 80 miles from the DC Passport Agency — but that doesn't mean faster self-service processing. Agency appointments are still required and typically booked 2+ weeks out. Our courier service is actually faster than trying to get a DC agency appointment.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Cross-State Vital Records Confusion",
      description: "Many Martinsburg-area residents were born in Maryland, Virginia, or Pennsylvania hospitals. When ordering birth certificates, you need the correct state's vital records office — not West Virginia. Our document review catches this immediately.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Photos from local pharmacies and big-box stores frequently fail State Department standards. We review all photos before submission to prevent rejection and delay.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Commuter Timeline Collapse",
      description: "DC commuters sometimes underestimate how much time passport processing adds to their already busy schedules. Between MARC train schedules, work commitments, and family obligations, passport tasks get pushed to the last minute. We provide a clear, time-boxed plan that fits a commuter lifestyle.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order — just a few minutes from home, office, or on the MARC train." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your departure airport — Dulles, BWI, or National." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using overnight shipping. Most Martinsburg clients use the UPS Store on Foxcroft Avenue or ship from home." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency channel — faster than a DC agency appointment, no 80-mile drive required." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport arrives at your Martinsburg address within your selected timeframe. No DC trip, no appointment scramble." },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned", "Daily status updates"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review", "No dedicated agent", "Updates only by mail", "Can't upgrade speed after submission"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — nearest is Washington DC (80 miles)", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — DC agency is 80 miles away. Booked 2+ weeks out", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 80 miles to DC (plus DC traffic and parking)", fpc: "Most Martinsburg travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission" },
    { feature: "Local Guidance", agency: "Generic — no Eastern Panhandle, commuter, or federal employee expertise", fpc: "Full Martinsburg/Dulles/commuter knowledge" },
    { feature: "Cost vs Resellers", agency: "Government fees only — you handle all logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Fast passport services in Charleston, WV", route: "/charleston" },
    { name: "Expedited passport in Morgantown, WV", route: "/morgantown" },
    { name: "Quick passport services in Wheeling, WV", route: "/wheeling" },
    { name: "Urgent passport services in Hagerstown, MD", route: "/hagerstown" },
    { name: "West Virginia passport services overview", route: "/west-virginia" },
  ],
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeNote: "Fast Passport Center serves Martinsburg via secure registered courier with direct access to the Washington, DC Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without the 80-mile DC drive and parking hassle. Martinsburg residents can ship from any UPS Store, FedEx Office, or post office in Berkeley County.",
  fpcOfficeDistance: "Serving Martinsburg, Shepherdstown, Inwood, Falling Waters, Hedgesville, and all Berkeley and Jefferson County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Martinsburg and the Eastern Panhandle. From downtown Martinsburg to Shepherdstown, from Inwood and Bunker Hill to Charles Town and Harpers Ferry — we serve all of Berkeley and Jefferson counties. Our courier service provides faster processing than a DC agency appointment, without the 80-mile drive.",
  nearbyCitiesIntro: "We serve Martinsburg and all Eastern Panhandle communities including Shepherdstown, Inwood, Falling Waters, Hedgesville, Charles Town, Ranson, and Harpers Ferry. We also serve nearby communities in Maryland (Hagerstown) and Virginia (Winchester). Travelers depart from Dulles, BWI, and National airports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Martinsburg as simple and predictable as possible. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you. Most Martinsburg travelers start online and ship documents overnight — perfect for DC commuters and busy Eastern Panhandle families.",
  mistakesIntro: "Martinsburg travelers encounter unique passport issues — from multi-airport selection to cross-state document confusion to commuter timeline challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Martinsburg travelers — from federal employees and government contractors to Shepherd University students and Eastern Panhandle families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Martinsburg, WV? Here are the most common ones from Eastern Panhandle travelers.",
  statePageRoute: "/states/west-virginia",
  statePageName: "West Virginia",
  servicesIntro: "Whether you need a renewal before a Dulles flight to Europe, an emergency passport for a federal training deployment, or a first-time passport for a Shepherd University study abroad — Fast Passport Center handles it with reserved courier submission. As a registered State Department courier, we guarantee the best price.",
  travelTiming: {
    title: "Travel & Passport Timing for Martinsburg Residents",
    intro: "Martinsburg's unique position as a DC commuter hub with three international airports within 80 miles creates distinct travel patterns. Here's what Martinsburg travelers need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "IAD — Washington Dulles International Airport",
        subtitle: "60 miles east, United Airlines global hub",
        description: "Dulles is the primary international gateway for Eastern Panhandle travelers. United Airlines' hub serves direct flights to London, Paris, Frankfurt, Tokyo, Dubai, and 50+ international destinations. The drive is about 60–75 minutes via WV-9 and the Dulles Greenway. Combined with international check-in, plan for 3.5–4 hours door to gate.",
        tip: "The Dulles Greenway (VA-267) is a toll road — budget about $6–8 each way. For early morning international flights, many Martinsburg travelers book a park-and-fly hotel near Dulles the night before.",
      },
      {
        icon: "ri-train-line",
        title: "The DC Commuter Factor",
        subtitle: "MARC train commuters with international travel needs",
        description: "Martinsburg is the western terminus of the MARC Brunswick Line, with daily commuter rail service to Washington Union Station. Hundreds of Berkeley County residents commute to DC for work — many at federal agencies with international travel requirements. The commuter lifestyle means passport tasks compete with long workdays and train schedules, often getting pushed to weekends and last-minute rushes.",
        tip: "If you commute to DC, consider using a DC-area acceptance facility during your lunch break — the DC Passport Agency at 600 19th St NW is a short walk from Farragut West Metro. But for actual processing speed, our courier service is still faster than trying to get a DC agency appointment.",
      },
      {
        icon: "ri-building-2-line",
        title: "Federal Employee & Contractor Travel",
        subtitle: "IRS, VA, Coast Guard, and DC-based agencies",
        description: "The Martinsburg area hosts a high concentration of federal employees and contractors — the IRS Computing Center (one of the largest IRS facilities outside DC), the VA Medical Center, and US Coast Guard operations. Federal travel authorizations often come with short notice — 7–14 days for training, deployments, and interagency meetings. Passports must be current and ready when the orders come through.",
        tip: "Federal travel orders don't check passport expiration. Maintain a current passport independently of your agency travel system. For government employees with security clearances, we handle documents with the confidentiality and care your position requires.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Three Airports, One Decision",
      description: "Martinsburg travelers have a rare luxury — three major international airports (IAD, BWI, DCA) within 80 miles. But this also creates decision complexity. Dulles has the most international routes, BWI is the Southwest hub for Caribbean and budget travel, and National is convenient for domestic connections. We help you build your passport timeline around your specific airport choice.",
    },
  },
  destinations: {
    title: "Where Martinsburg Travelers Go",
    intro: "Martinsburg's federal workforce, commuter population, and Eastern Panhandle location create distinct international travel patterns.",
    stats: [
      { stat: "38%", label: "of Martinsburg expedited requests are federal employee or contractor-related" },
      { stat: "1–2 Weeks", label: "average lead time for government and contractor travel bookings" },
      { stat: "May–Aug", label: "peak season when federal training, summer vacations, and study abroad overlap" },
      { stat: "3 Days", label: "shortest turnaround for an IRS cybersecurity specialist deploying to London" },
    ],
    destinations: [
      { name: "Germany", context: "Federal IT and cybersecurity training, military contractor deployments, Dulles-Frankfurt direct flights", urgency: "Government training dates fixed and often assigned 7–14 days out", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom", context: "IAD-London direct flights, IRS and federal interagency meetings, contractor supplier visits", urgency: "Agency travel authorizations typically 5–10 days before departure", icon: "ri-map-pin-2-line" },
      { name: "Spain & Italy", context: "Shepherd University study abroad programs, DC-area federal employees' European vacations", urgency: "Study abroad acceptances 6–8 weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "Dulles-Tokyo direct flights, federal cybersecurity exchanges, government contractor travel", urgency: "Long-haul travel often booked 3–4 weeks out with fixed meeting dates", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "BWI Southwest flights, family resort vacations, spring break trips, cruise departures", urgency: "Spring break and winter escape bookings peak November–February", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "DCA and BWI connections to Toronto, federal interagency meetings, family Niagara Falls trips", urgency: "Cross-border government meetings often booked 1 week out", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other West Virginia Service Areas",
    crossLinksDesc: "We serve travelers across the Mountain State.",
    crossLinks: [
      { name: "Charleston", route: "/charleston" },
      { name: "Huntington", route: "/huntington" },
    ],
  },
};